import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "../../assets/css/carousel.scss";
import "../../assets/css/grid.scss";
import "../../assets/css/style.scss";
import Header from "../layout/Header";
import Banner from "../common/Banner";

import Exclusive from "../common/Exclusive";
// import Faq from "../common/Faq";
import Footer from "../layout/Footer";
// import PlansListStatic from "../common/PlansListStatic";

import Bannerinner from "../common/Bannerinner";
import Bannergiveaway from "../common/Bannergiveaway";
import Giveaways from "../common/Giveaways";
import Searchcard from "../common/Searchcard";
import Cards from "../common/Cards";
import Cardsgiveaway from "../common/Cardsgiveaway";
import Headings from "../common/Headings";
import * as benefitApis from 'apis/benefits';
import OfferCard from 'components/common/OfferCard';
import './OfferPage.scss';

const SKELETON_COUNT = 8;

function OfferPage() {
  const navigate = useNavigate();
  const [benefits, setBenefits] = useState([]);
  const [loading, setLoading] = useState(true);

  // The offer itself lives behind the members-only dashboard, so signed-out
  // visitors are sent to sign up and land on the offer once they are in.
  const handleGetOffer = (benefit) => {
    const target = `/dashboard/offers/${benefit.id}`;
    const token = localStorage.getItem('token');
    if (token) {
      navigate(target);
    } else {
      sessionStorage.setItem('postLoginRedirect', target);
      navigate('/Plans#plans');
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Public listing: /v1/benefits returns the top rated benefits only.
        const response = await benefitApis.fetchBenefits();
        setBenefits(response.data || []);
      } catch (error) {
        console.log(error);
        setBenefits([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  return (
    <div className="App offers-page">
      {/* offer page */}
      <Header />
      <Bannerinner />
      {/* <Searchcard /> */}
      <div className="container-fluid public-offers">
        <div className="container">

          <div className="public-offers-head">
            <span className="public-offers-eyebrow">Members only</span>
            <h2>Top Rated Offers</h2>
            <p>A taste of what our members unlock every day. Sign up to reveal the codes and start saving.</p>
          </div>

          <div className="public-offers-note">
            <i className="fa-solid fa-lock" />
            Discount codes are hidden until you join
          </div>

          <div className="row py-400">
            {loading && (
              Array.from({ length: SKELETON_COUNT }, (_, index) => (
                <div key={`skeleton-${index}`} className="col-12 col-lg-3 p-150">
                  <div className="public-offers-skeleton" />
                </div>
              ))
            )}

            {!loading && benefits.length === 0 && (
              <div className="col-12 p-150">
                <div className="public-offers-empty">
                  <i className="fa-solid fa-tags" />
                  <h4>No offers here yet</h4>
                  <p>New offers are added regularly - check back soon.</p>
                </div>
              </div>
            )}

            {
              !loading && benefits.map(benefit => (
                <div key={benefit.id} className="col-12 col-lg-3 p-150">
                  <OfferCard
                    benefit={benefit}
                    showCode={false}
                    showWebsite={false}
                    ctaIcon="fa-solid fa-lock-open"
                    ctaLabel="Sign Up to View Offer"
                    onOfferClick={handleGetOffer}
                  />
                </div>
              ))
            }
          </div>
        </div>
      </div>
      {/* <Exclusive /> */}

      {/* Same plan tiles as the /Plans page, minus that page's own hero -
          this page already has its banner - and minus the trust strip, which
          would run long after the offers grid. */}
      {/* <PlansListStatic showHero={false} showTrustStrip={false} /> */}

      {/* <Faq theme="dark" /> */}
      <Footer />


    </div>
  );
}

export default OfferPage;
